module.exports = __webpack_public_path__ + "static/favicon-d721b4a98b9cfa4a92c8d3609fc4f81a.ico";